<svg
    class="cloud-svg"
    [attr.width]="size()"
    [attr.height]="size()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 300">
    <!-- Gradient definitions -->
    <defs>
        <linearGradient
            id="cloudGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%">
            <stop
                offset="0%"
                style="stop-color: #a5b4e6" />
            <stop
                offset="50%"
                style="stop-color: #c2e9f0" />
            <stop
                offset="100%"
                style="stop-color: #e0f4f1" />
        </linearGradient>
    </defs>

    <!-- Larger cloud -->
    @if (!hideLargeCloud()) {
        <path
        d="M150,100 
    A70,50 0 0,1 300,100 
    A60,60 0 0,1 340,160
    A70,70 0 0,1 280,220
    A80,80 0 0,1 140,220
    A60,60 0 0,1 90,160
    A70,70 0 0,1 150,100"
        fill="url(#cloudGradient)" />
    }

    <!-- Smaller cloud -->
    <path
        d="M220,140
               A50,50 0 0,1 320,140
               A40,40 0 0,1 350,180
               A50,50 0 0,1 310,220
               A60,60 0 0,1 210,220
               A40,40 0 0,1 180,180
               A50,50 0 0,1 220,140"
        fill="url(#cloudGradient)"
        opacity="0.9" />
</svg>
